import services from 'services/services';

// Import types
import { type EpgList } from 'types/api/epg';
import type { ChannelListResponse, ChannelInList } from 'types/api/products/channels';

// Import helpers
import { convertParamsDateFormat } from 'store/helpers/epg';
import { removeAdultChannels } from 'store/actions/tv/channels/helpers';

export const fetchChannelsList = (): Promise<ChannelInList> =>
	services
		.get<ChannelListResponse>('/products/channel', { params: { offset: 0, limit: 300 } })
		.then((response) => response.data.data)
		.then(removeAdultChannels);

export const fetchEpg = async (since: string, till: string, signal?: AbortSignal) => {
	const startDate = convertParamsDateFormat(since);
	const endDate = convertParamsDateFormat(till);
	const response = await services.get<EpgList>('/epg', { params: { startDate, endDate }, signal });
	return response.data;
};
